import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  useHistory,
  useParams,
  withRouter,
  useLocation,
} from 'react-router-dom'
import { routes } from '../../../../constantes/routes'
import TasksForm from '../TasksForm'
import { swalAlertError, swalSuccessGeneral } from '../../../../utils/swalAlert'
import { swalTitle } from '../../../../constantes/swalTitle'
import { onSubmitText } from '../../../../constantes/onSubmitText'
import Header from '../../../header/Header'
import { tasksActions } from '../../../../actions/tasksActions'
import { businessunitsActions } from '../../../../actions/businessunitsActions'
import { swalMssgs } from '../../../../constantes/swalMssgs'
import { contactsApi } from '../../../../api/contactsApi'
import validators from '../../../../utils/validationsRegEx'

const EditTaskContainer = () => {
  const { id } = useParams()
  const history = useHistory()
  const location = useLocation()

  // Detectar de dónde viene la navegación
  const searchParams = new URLSearchParams(location.search)
  const fromCrm = searchParams.get('from') === 'crm'
  const fromCalendar = searchParams.get('from') === 'calendar'

  const events = useSelector((state) => state.events)
  const phases = useSelector((state) => state.phases)
  const tasks = useSelector((state) => state.tasks)
  const businessunits = useSelector((state) => state.businessunits)

  const dispatch = useDispatch()
  const editTask = (task) => dispatch(tasksActions.updateTask(task))
  const getAllBusinessUnits = () =>
    dispatch(businessunitsActions.getAllBusinessUnits())

  const [contacts, setContacts] = useState([])
  const [inputs, setinputs] = useState({
    id_Crm: id,
    id_Usuario: '',
    id_Contacto: '',
    id_TipoFase: '',
    id_TipoAsunto: '',
    id_TipoEvento: null,
    asunto: '',
    fecha: new Date(),
    descripcion: '',
    isVerCaledario: false,
    businessUnits: [],
  })
  const [isDisable, setIsDisable] = useState(false)

  useEffect(() => {
    getTaskById(id)
    getAllContacts()
    getAllBusinessUnits()
  }, [id])

  const getTaskById = async (idTask) => {
    try {
      const task = tasks.find((x) => x.id_Crm.toString() === idTask)

      // Transformar id_NegocioUnidades a businessUnits para el frontend
      const businessUnits = task.id_NegocioUnidades
        ? businessunits.filter((bu) => task.id_NegocioUnidades.includes(bu.id))
        : []

      Object.keys(inputs).map((input) => {
        if (input === 'businessUnits') {
          setinputs((inputs) => ({ ...inputs, [input]: businessUnits }))
        } else {
          setinputs((inputs) => ({ ...inputs, [input]: task[input] }))
        }
        return null
      })
    } catch (error) {
      if (error.response.data.message) {
        alert(error.response.data.message)
      } else {
        alert(error.response.data)
      }
    }
  }

  const getAllContacts = async () => {
    try {
      const response = await contactsApi.getAllContacts()

      if (response.data) setContacts(response.data)
    } catch (error) {
      swalAlertError(error)
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setIsDisable(true)
    try {
      // Transformar businessUnits a id_NegocioUnidades para el backend
      const { businessUnits, ...taskDataBase } = inputs
      const taskData = {
        ...taskDataBase,
        id_NegocioUnidades: businessUnits.map((bu) => bu.id),
      }

      await editTask(taskData)
      swalSuccessGeneral(swalTitle.Actualizado, swalMssgs.UPDATE_SUCCES)
      // Navegar según de dónde viene
      if (fromCrm) {
        history.push(routes.CRM)
      } else if (fromCalendar) {
        history.push(routes.CALENDAR)
      } else {
        history.push(routes.MANAGEMENT)
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
      setIsDisable(false)
    }
  }

  const validateForm = () => {
    return (
      validators.hasValue(inputs.id_Contacto) &&
      validators.hasValue(inputs.id_TipoFase) &&
      //&& validators.hasValue(inputs.id_TipoZona)
      validators.hasValue(inputs.id_TipoAsunto) &&
      validators.hasValue(inputs.fecha) &&
      inputs.businessUnits.length > 0
    )
  }

  const handleChange = (event) => {
    const name = event.target.name
    const value =
      name === 'isVerCaledario' ? event.target.checked : event.target.value
    setinputs((inputs) => ({ ...inputs, [name]: value }))
  }

  const goBack = () => {
    if (fromCrm) {
      history.push(routes.CRM)
    } else if (fromCalendar) {
      history.push(routes.CALENDAR)
    } else {
      history.push(routes.MANAGEMENT)
    }
  }
  return (
    <>
      {
        <div className='history-wrap'>
          <div className='products'>
            <Header text={'Editar lead'} route={goBack} backBtn={true} />
            <TasksForm
              inputs={inputs}
              contacts={contacts}
              events={events}
              phases={phases}
              businessunits={businessunits}
              isDisable={isDisable || !validateForm()}
              handleSubmit={handleSubmit}
              handleChange={handleChange}
              textBtn={onSubmitText.Guardar}
            />
          </div>
        </div>
      }
    </>
  )
}
export default withRouter(EditTaskContainer)
